import React, { useState, useEffect } from 'react';
import { KFLButton, KFLInput, KFLSpinner } from '@kamstrup/kamstrup-frontend-library';
import Translate from '../shared/localization/localize';
import * as Devices from '../../modules/devices';
import * as Register from '../../modules/dialogs/register';
import { AppKeys, MessageType, TranslateType } from '../../core/localization';
import SVGIcon, { SVGIcons } from '../shared/svgIcon';
import { submitForm } from '../../utils';

interface Props {
  translate: TranslateType;
  editingItem?: Register.RegisterDevice;
}

const RegisterForm: React.FC<Props> = (props) => {
  const [error, setError] = useState('' as MessageType);
  const [key, setKey] = useState('');
  const [code, setCode] = useState('');

  useEffect(() => {
    setKey(props.editingItem ? Devices.getPK(props.editingItem) : '');
    setCode(props.editingItem ? props.editingItem.code : '');
    setError(props.editingItem ? props.editingItem.errorMsg : '');
  }, [props.editingItem]);

  useEffect(() => {
    const errorMessge = Register.validateForm(key, code, true);
    setError(errorMessge);
  }, [key, code]);

  const addDevice = () => {
    const errorMessge = Register.validateForm(key, code);
    if (String(errorMessge) === '') {
      const deviceId = Devices.parsePK(key);
      deviceId && Register.validateDevice(deviceId, code);
    } else setError(errorMessge);
  };

  const msgSN = props.translate(AppKeys.Device_Prop_SeriaNumber);
  const msgCode = props.translate(AppKeys.Register_Code_Input);
  const msgAddDeviceBtn = props.translate(AppKeys.Btn_AddToList);
  const msgValidating = props.translate(AppKeys.Com_Validating);

  const isReadyToAdd = !String(error) && key && code;
  const isFetching = props.editingItem && props.editingItem.isFetching;

  return (
    <div className="register_form">
      <div className="register_fields" onKeyDown={submitForm(addDevice)}>
        <KFLInput
          id="dg-register-input-sn"
          label={msgSN}
          placeholder="E.g. KAM12345678"
          type="text"
          value={key}
          onChange={setKey}
        />
        <KFLInput
          id="dg-register-input-code"
          label={msgCode}
          placeholder="E.g. A0"
          type="text"
          value={code}
          onChange={setCode}
        />
      </div>
      <div className="register_feedback">
        {error && (
          <div className="register_error">
            <SVGIcon
              name={SVGIcons.Flag}
              fill="red"
              width="20px"
              height="20px"
            />
            <Translate message={error} />
          </div>
        )}
        {isFetching && (
          <div className="register_validating">
            <KFLSpinner height={20} width={20} />
            <span>{msgValidating}</span>
          </div>
        )}
      </div>
      <KFLButton
        id="dg-register-btn-add"
        onClick={addDevice}
        disabled={!isReadyToAdd || isFetching}
      >
        {msgAddDeviceBtn}
      </KFLButton>
    </div>
  );
};

export default RegisterForm;
